"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Chart_1 = __importDefault(require("../Chart/Chart"));
/**
 *  The Gauge is used to visualize a single data point within a range. This Component is being deprecated. It is being replaced by <Chart.Gauge />.
 */
var GaugeChart = /** @class */ (function (_super) {
    __extends(GaugeChart, _super);
    function GaugeChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GaugeChart.prototype.render = function () {
        var _a = this.props, min = _a.min, max = _a.max, value = _a.value, zones = _a.zones, diameter = _a.diameter, endAngle = _a.endAngle, startAngle = _a.startAngle, suffix = _a.suffix, title = _a.title, gaugeColor = _a.gaugeColor;
        return (React.createElement(Chart_1.default, { title: title, showTooltips: false },
            React.createElement(Chart_1.default.Pane, { startAngle: startAngle, endAngle: endAngle, size: diameter }),
            React.createElement(Chart_1.default.Gauge, { data: [{ y: value, color: gaugeColor }] },
                React.createElement(Chart_1.default.CenterBlock, null,
                    React.createElement("span", { className: "gauge-center-label" }, value),
                    React.createElement("span", { className: "gauge-center-suffix" }, suffix))),
            React.createElement(Chart_1.default.YAxis, { min: min, max: max, variant: "gauge" }, zones &&
                zones.map(function (zone) { return (React.createElement(Chart_1.default.PlotBand, { variant: "gauge", from: zone.min, to: zone.max, color: zone.color, label: zone.label })); }))));
    };
    GaugeChart.defaultProps = {
        gaugeColor: 'blue'
    };
    return GaugeChart;
}(React.Component));
exports.default = GaugeChart;
//# sourceMappingURL=Gauge.js.map